<template>
  <div>
    <ed-form
      :data="formData"
      :response="response"
      :config="config"
      :itens="formDataItems"
    >
      <div slot="form-footer">
        <div class="col-md-12 btn-login">
          <ed-button
            icon="fa fa-floppy-o"
            type="success"
            @click="salvar"
            :loading="config.loading.save"
            value="Salvar"
          />
        </div>
      </div>
    </ed-form>
  </div>
</template>

<script>
import Rest from "common/rest";
import EdForm from "common/form";
import EdButton from "common/button";
import ItemsFormEditar from "./_form/funcionario-editar";

export default {
  components: {
    EdForm,
    EdButton,
  },
  mixins: [Rest],
  watch: {
    "formData.id_fdt"() {
      if (!this.config.loading.save) {
        //this.formData.id_funcao = null;
      }
      //this.getFuncao();
    },
    "formData.id_funcao"() {
      if (!this.config.loading.save) {
        //this.formData.id_ghe = null;
      }
      this.getGHE();
    },
  },
  data() {
    return {
      loadingContent: false,
      loadingSave: false,
      response: {},
      formDataItems: [],
      config: {
        estado: true,
        click: {
          id_fdt: this.getFDT,
          id_ghe: this.getGHE,
          id_funcao: this.getFuncao,
        },
        list: {
          id_fdt: [],
          id_ghe: [],
          id_funcao: [],
        },
        loading: {
          id_fdt: false,
          id_ghe: false,
          id_funcao: false,
          save: false,
        },
        tipo: [59],
      },
      formData: {
        id: 0,
        id_estado: null,
        id_cidade: null,
        id_funcao: null,
        id_fdt: null,
        id_ghe: null,
        nome: null,
        cpf: null,
        rg: null,
        cep: null,
        end: null,
        num: null,
        bairro: null,
        comp: null,
        ct_num: null,
        ct_serie: null,
        ct_uf: null,
        tel_res: null,
        tel_cel: null,
        dt_nas: null,
        sexo: null,
        email: null,
        mat: null,
        pis: null,
        status: null,
        pcd: 0,

        obs: null,
        created_at: null,
        updated_at: null,
      },
    };
  },

  created() {},

  mounted() {
    this.getFuncionario();
    this.formDataItems = ItemsFormEditar;
  },

  methods: {
    getFuncao(_search) {

      this.config.loading.id_funcao = true;
      this.config.list.id_funcao = [];

      var filter = {
        id_fdt: this.formData.id_fdt,
      };

      this.get("funcao", {
        search: _search,
        filter: filter,
        pagination: 1000,
      }).then((result) => {
        result = result[0];

        this.config.loading.id_funcao = false;

        if (result.status == 200) {
          this.config.list.id_funcao = result.data.data;

          if (this.formData.id_funcao) {
            if (
              !this.arrFindByField(
                this.config.list.id_funcao,
                "id",
                this.formData.id_funcao
              )
            ) {
              this.formData.id_funcao = null;
              this.formData.id_ghe = null;
              this.config.list.id_ghe = [];
            }
          }
        }

        this.config.loading.save = false;
      });
    },

    getFDT() {
      this.config.loading.id_fdt = true;
      this.config.list.id_fdt = [];
      let filter = {
        ativo: 1,
      };
      this.get("pcmso/fdt", {
        filter: filter,
      }).then((result) => {
        result = result[0];

        this.config.loading.id_fdt = false;

        if (result.status == 200) {

      
          this.config.list.id_fdt = result.data.data;
          this.getFuncao();
        }

      });
    },

    getGHE() {
      if (!this.formData.id_funcao) return;

      this.config.loading.id_ghe = true;
      this.config.list.id_ghe = [];

      var filter = {
        id_fdt: this.formData.id_fdt,
        id_funcao: this.formData.id_funcao,
      };

      this.get("pcmso/ghe", {
        filter: filter,
        pagination: 100,
      }).then((result) => {
        result = result[0];

        this.config.loading.id_ghe = false;

        if (result.status == 200) {
          this.config.list.id_ghe = result.data;

          let encontrado = false;
          result.data.forEach((revisao, index) => {
            if (
              this.$utilidade.arrFindByField(
                revisao.options,
                "id",
                this.formData.id_ghe
              )
            ) {
              encontrado = true;
            }
          });

          if (this.formData.id_ghe && !encontrado) {
            this.formData.id_ghe = null;
          }
        }
      });
    },

    getFuncionario() {
      this.config.loading.save = true;

      this.get("funcionario/0/" + this.$route.params.id).then((result) => {
        result = result[0];

        this.response = result;

        if (result.status == 200) {
          var data = result.data;

          if(data.funcao){
            //this.getFuncao(data.funcao.nome)
            //this.config.list.id_funcao = [data.funcao]
          }

          this.formData = {
            id: data.id,
            id_estado: data.id_estado == "0" ? null : data.id_estado,
            id_cidade: data.id_cidade == "0" ? null : data.id_cidade,
            id_funcao: data.id_funcao,
            id_fdt: data.id_pcmso ? data.id_pcmso : null,
            id_ghe: data.id_ghe ? data.id_ghe : null,
            _id_ghe: data._id_ghe ? data._id_ghe : null,
            nome: data.nome,
            cpf: data.cpf,
            rg: data.rg,
            dt_nas: data.dt_nas ? this.toDate(data.dt_nas, true) : null,
            dt_nas: data.dt_nas,
            email: data.email,
            tel_res: data.tel_res,
            tel_cel: data.tel_cel,
            cep: data.cep,
            end: data.end,
            num: data.num,
            bairro: data.bairro,
            comp: data.comp,
            obs: data.obs,
            ct_num: data.ct_num,
            ct_serie: data.ct_serie,
            pcd: data.pcd,
            ct_uf: data.ct_uf,
            sexo: data.sexo,
            mat: data.mat,
            pis: data.pis,
            user_edit: 1,
            created_at: data.created_at,
            updated_at: data.updated_at,
          };
        } else {
          if (result.status == 404)
            this.toRoute({
              name: "empresa.funcionario",
            });
        }

        this.config.loading.save = false;
        this.getFDT();
      });
    },

    salvar() {
      this.config.loading.save = true;
      this.response = {};

      this.post("funcionario/0/editar", this.formData).then((result) => {
        result = result[0];

        this.config.loading.save = false;
        this.response = result;

        if (result.status == 200) {
          console.log(result);
          this.edMsg("Dados atualizados com sucesso");
          this.getFuncionario();
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// editar.vue?fece6012